import { View } from "react-native"
import Animated, {
  Extrapolate,
  interpolate,
  interpolateColor,
  useAnimatedStyle,
} from "react-native-reanimated"
import React from "react"
import { style } from "../styles"

export const PaginationItem: React.FC<{
  index: number
  length: number
  animValue: Animated.SharedValue<number>
}> = ({ animValue, index }) => {
  const animStyle = useAnimatedStyle(() => {
    const inputRange = [index - 1, index, index + 1]

    const opacity = interpolate(
      animValue.value,
      [index - 1, index, index + 1],
      [0.3, 1, 0.3],
      Extrapolate.CLAMP,
    )

    const scale = interpolate(
      animValue.value,
      [index - 1, index, index + 1],
      [1, 1.5, 1],
      Extrapolate.CLAMP,
    )

    const backgroundColor = interpolateColor(
      animValue.value,
      inputRange,
      ["#D3D3D3", "#FFA500", "#D3D3D3"], // light gray to orange to light gray
    )

    return {
      opacity,
      transform: [{ scale }],
      backgroundColor,
    }
  })

  return <Animated.View style={[style.paginationDot, animStyle]} />
}
